<template>
    <div>
        <el-table
                size="mini"
                border
                ref="multipleTable"
                :data="detailsData"
                row-key="vc_unique"
                height="220"
                tooltip-effect="dark"
                :row-class-name="tableRowClassName"

                @selection-change="handleSelectionChange"
                style="width: 100%">
            <el-table-column
                    align="left"
                    type="selection"
                    :reserve-selection="true"
                    width="55">
            </el-table-column>
            <el-table-column
                    align="left"
                    prop="vc_yskhname"
                    :label="$t('form_company')"
                    show-overflow-tooltip>
            </el-table-column>
        </el-table>
        <el-pagination
                class="txtr"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage"
                :page-sizes="[10, 15, 30]"
                :page-size="pageSize"
                layout="sizes, prev, pager, next"
                :total="tableTotal">
        </el-pagination>
        <div slot="footer" class="dialog-footer" style="text-align: center;margin-top: 20px">
            <el-button type="primary" @click="saveForm" :class="baseerp+'btn'" size="small" :disabled="disabled">{{$t('button_confirm')}}</el-button>
            <el-button @click="cancel" size="small">{{$t('button_cancel')}}</el-button>
        </div>

    </div>
</template>

<script>
    import * as API from "./../api"
    import {baseerp} from "@/utils/baseUrl";
    export default {
        name: "ProductDetails",
        props:{
            /*productDetails:{
                type:Object,
                required:true,
            }*/
        },
        data() {
            return {
                pageSize:15,
                currentPage:1,
                tableTotal:0,
                i_htid:0,
                /****************/
                cpinput:"",
                multipleSelection:"",
                detailsData:[],
                /*currentPage:0,
                tableTotal:0,
                pageSize:1,
                pageCount:1,*/
                gsid:0,
                gsid_out:0,
                i_pzid:0,
                ckid:0,
                baseerp:"",
                mid:0,
                dataText:this.$t('tips_data_loading_in_progress'),
                disabled:false,
                selected:[],
            }
        },
        mounted() {
            this.baseerp=baseerp;
            //console.log(this.productDetails,"mounted");
           // this.i_htid=this.productDetails.i_htid;
            this.searchSportCompany();
            //this.mid=this.productDetails.i_mid;
            //this.selected=this.productDetails.selected;
            /*this.ckid=this.productDetails.i_ckid;
            this.gsid_out=this.productDetails.i_gsid_out;
             this.i_pzid=this.productDetails.i_pzid;*/
            //this.getWarehousingProductList();
        },
        methods: {
            handleSizeChange(val){
                //console.log(val,"page_count");
                this.pageSize=val;
                this.currentPage=1;
                ///调用列表接口
                this.gethtlist();
            },
            handleCurrentChange(val){
                //console.log(val,"page_size");
                this.currentPage=val;
                ///调用列表接口
                this.gethtlist();
            },

            //查询运输公司
            async searchSportCompany() {
                let params = {
                    vc_search:"",
                    vc_type:3,
                    page_size:this.currentPage,
                    page_count: this.pageSize,
                }
                let res = await API.searchSportCompany(params);
                if (res.code == 1) {
                    this.detailsData=res.data
                    ////console.log(this.ysgsdata,"this.ysgsdata")
                } else if (res.code == -2) {
                    this.$message.error(res.message)
                } else {
                    this.$message.error(res.message)
                }
            },

            //列表
            async getPzListByHtid(){
                let param={
                    i_htid:this.i_htid,
                };
                let res=await API.getPzListByHtid(param);
                if(res.code==1){
                    if (res.data.length==0){
                        this.dataText=this.$t('tips_no_data_available_at_the_moment')
                    }
                    this.detailsData=res.data;
                    if (this.selected){
                        if (this.detailsData.length>0&&this.selected.length>0) {
                            this.selected.forEach(row => {
                                this.$refs.multipleTable.toggleRowSelection(row);
                            });
                        }
                    }
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            searchData(){
                this.detailsData=[];
                /*this.pageSize=1;
                this.currentPage=1;*/
                this.getWarehousingProductList();
            },
            cancel(){
                this.$emit('closePop');
            },

            handleSelectionChange:function(val) {
                //console.log(val)
                if(val.length==1){
                    this.multipleSelection = val;
                }else if(val.length>1){
                    this.$message.error("您已选择公司不能多选");
                    this.multipleSelection = [];
                    this.$refs.multipleTable.clearSelection();
                }
            },

            tableRowClassName({row,rowIndex}){
                //console.log(row.i_gsid,this.gsid)
                /*if(row.i_gsid!=this.gsid){
                    return 'danger-row';
                }*/
                if (row.isother == 1) {
                    return 'danger-row';
                }
            },
            saveForm(){
                this.disabled=true;
                this.$emit('transValue',this.multipleSelection);
                this.$emit('closePop');
            },
            pageCurrentChange(val){
                this.detailsData=[];
                /*this.pageSize=val;
                this.currentPage=val;*/
                this.getWarehousingProductList();
            },
        },
    }
</script>

<style lang="scss" scoped>
    .txtr{
        text-align: right;
    }
    .searchName{
        width: 100px; display: inline-block;vertical-align: middle;text-align: center;
    }
    .mr10{
        width: 50%;
    }

    /deep/{
        .danger-row{
            color: #999;
        }
    }
</style>